export enum EAddressStatus {
  neizmantot = 'neizmantot',
  izmantot = 'izmantot',
  verificēts = 'verificēts',
}
